import Header from '../../Header';
import './Success.css';



function Success(){

    

    return(
        <>
        <div class="cropCutter">
        <Header/>
        <section  id="mainBackground" class="hero is-fullheight">
            <div id="layer" class="hero-body">
            <div class="center">
            <div>
            <p id="success" class="title"> Success ! <br/> You can give us a follow on IG at @naturalseducer ! &#x1F60A;</p>
            
            </div>
            
            </div>
            </div>
        </section>
        </div>
        
        </>
    );
}

export default Success;